module.exports = "\r\n    <div>\r\n         <b>{{fornecedor.nome}}</b>\r\n    </div>\r\n\r\n"